import { Button, HStack, Text, VStack } from "@/components/sgBootstrapReactWrapper";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setSigmaOperationDisplayedInDrawer, sigmaOperationDisplayedInDrawer } from "@/store/position/slice";
import { isNotDefined } from "@/utils/assertions";
import { FormattedMessage } from "react-intl";
import SigmaOrderHistoryArray from "./SigmaOrderHistoryArray";

export default function SigmaOrderHistoryDrawer() {
  const operation = useAppSelector(sigmaOperationDisplayedInDrawer)
  const dispatch = useAppDispatch()
  if (isNotDefined(operation)) return null;
  const { orderHistories, clientOrderHistories } = { ...operation }
  const onClose = () => dispatch(setSigmaOperationDisplayedInDrawer(null))

  const header = <VStack gap="16px" padding="24px">
    <HStack className="justify-content-between">
      <Text className="display-4">
        <FormattedMessage id="sigma.history.title" />
      </Text>
      <Button
        size="sm"
        purpose="flat"
        onClick={onClose}
        className="p-8px"
        data-e2e="instrument-drawer-close">
        <em className="icon icon-lg text-primary">close</em>
      </Button>
    </HStack>
    <HStack padding="4px" className="justify-content-between border-bottom">
      <span className="fw-medium text-secondary">
        <FormattedMessage id="sigma.history.operationReference" />
      </span>
      {operation.operationReference}
    </HStack>
    <HStack padding="4px" className="justify-content-between border-bottom">
      <span className="fw-medium text-secondary">
        <FormattedMessage id="sigma.history.isin" />
      </span>
      {operation.isin}
    </HStack>
  </VStack>
  const orderArray = <SigmaOrderHistoryArray data={orderHistories} titleLabelId="array.name.sigmaOrderHistory" />
  const clientOrderArray = <SigmaOrderHistoryArray data={clientOrderHistories} titleLabelId="array.name.sigmaClientOrderHistory" />

  return <div>
    <div
      data-e2e="sigma-history-drawer"
      className="offcanvas offcanvas-end show px-8px"
      style={{ minWidth: '920px' }}>
      <VStack className="h-100">
        {header}
        {clientOrderArray}
        {orderArray}
      </VStack>
    </div>

    <div className="offcanvas-backdrop fade show" onClick={onClose} />
  </div>
}